<template>
  <div class="funcionario-details">
    <page-header :title="title" />
    <page-section>
      <v-row no-gutters>
        <v-col class="mb-4" cols="12" md="4">
          <field-section
            :label="$t('Cargo')"
            :value="tag.empCarFun.cargo.nome ? tag.empCarFun.cargo.nome : null"
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('cargo')"
          />
        </v-col>
        <v-col class="mb-4" cols="12" md="6">
          <field-section
            :label="$t('Função')"
            :value="
              tag.empCarFun.funcao.nome ? tag.empCarFun.funcao.nome : null
            "
            :is-restrict="$store.getters['tagFuncionario/isRestrict']('funcao')"
          />
        </v-col>
      </v-row>
    </page-section>
    <Form :title="title" :data="tag" />
  </div>
</template>

<script>
import i18next from "i18next";
import PageHeader from "@/components/headers/page-header";
import PageSection from "@/components/sections/page-section";
import FieldSection from "@/components/sections/field-section";
import Form from "./form";
export default {
  metaInfo: {
    titleTemplate: (i18next.t("Funcionario") || "") + " | %s",
  },
  components: {
    FieldSection,
    PageSection,
    PageHeader,
    Form,
  },
  data: () => ({
    title: i18next.t("Funcionario"),
  }),
  computed: {
    tag() {
      return this.$store.state.tagFuncionario.data || {};
    },
  },
};
</script>

<style scoped></style>
